import { fetch, Method } from 'core/api/fetch';
import { getFormattedPrices, getFormattedPricesToUpdate, getFormattedRanges } from '../parser/priceGroup';

const BASE_URL = '/api/v1.1.1/experiencer/pricegroup/';

const PriceGroupRoutes = {
    create: BASE_URL,
    priceGroupById: (priceGroupId) => `${BASE_URL}${priceGroupId}`,
    unit: (priceGroupId) => `${BASE_URL}${priceGroupId}/unit`,
    range: (priceGroupId) => `${BASE_URL}${priceGroupId}/range`,
    unitById: (priceGroupId, unitId) => `${BASE_URL}${priceGroupId}/unit/${unitId}`,
    deleteRange: (priceGroupId, quantityFrom, quantityTo) => `${BASE_URL}${priceGroupId}/range?quantityFrom=${quantityFrom}&quantityTo=${quantityTo}`,
};

export const PriceGroupService = {
    create: async ({ priceGroupTabId, priceGroupData, priceData }) => {
        try {
            const { priceType, currency: currencySelected, priceRanges } = priceData;
            const prices = getFormattedPrices(priceRanges);

            const originIds = priceGroupData?.originIds?.map((origin) => origin?.id);
            const currency = currencySelected?.label;

            const formData = {
                ...priceGroupData,
                originIds,
                priceGroupTabId,
                priceType,
                currency,
                prices,
            };

            const { data } = await fetch(PriceGroupRoutes.create, {
                method: Method.POST,
                authenticated: true,
                data: formData,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    getById: async (priceGroupId) => {
        try {
            const { data } = await fetch(PriceGroupRoutes.priceGroupById(priceGroupId), {
                method: Method.GET,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    update: async ({ priceGroupId, priceGroupData, origins = [], priceData }) => {
        try {
            if (!Number.isInteger(priceGroupId)) return false;

            const data = getFormattedPricesToUpdate(priceGroupData, origins, priceData);

            if (Object.values(data)?.length === 0) return false;

            const { data: response } = await fetch(PriceGroupRoutes.priceGroupById(priceGroupId), {
                method: Method.PATCH,
                authenticated: true,
                data,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return response;
        } catch (error) {
            throw error;
        }
    },

    addUnit: async ({ priceGroupId, unitId, priceRanges }) => {
        try {
            const prices = getFormattedPrices(priceRanges);

            const { data } = await fetch(PriceGroupRoutes.unit(priceGroupId), {
                method: Method.POST,
                authenticated: true,
                data: { unitId, prices },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    addRange: async ({ priceGroupId, priceRanges }) => {
        try {
            const prices = getFormattedPrices(priceRanges);

            const { data } = await fetch(PriceGroupRoutes.range(priceGroupId), {
                method: Method.POST,
                authenticated: true,
                data: { prices },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    editUnit: async ({ priceGroupId, oldUnitId, newUnitId }) => {
        try {
            const { data } = await fetch(PriceGroupRoutes.unitById(priceGroupId, oldUnitId), {
                method: Method.PATCH,
                authenticated: true,
                data: { newUnitId },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    editRanges: async ({ priceGroupId, oldRanges, newRanges }) => {
        try {
            const ranges = getFormattedRanges(oldRanges, newRanges);

            const { data } = await fetch(PriceGroupRoutes.range(priceGroupId), {
                method: Method.PATCH,
                authenticated: true,
                data: { ranges },
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    deleteUnit: async ({ priceGroupId, unitId }) => {
        try {
            const { data } = await fetch(PriceGroupRoutes.unitById(priceGroupId, unitId), {
                method: Method.DELETE,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },

    deleteRange: async ({ priceGroupId, quantityFrom, quantityTo }) => {
        try {
            const { data } = await fetch(PriceGroupRoutes.deleteRange(priceGroupId, quantityFrom, quantityTo), {
                method: Method.DELETE,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return data;
        } catch (error) {
            throw error;
        }
    },
};
